<template>
  <v-container>
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <h2 class="mb-5">Cliente Oculto {{ municipio.nome }}/{{ municipio.uf }}</h2>
    <h3 class="mb-5" v-if="googleMeuNegocio && googleMeuNegocio.resposta">
      Nome da Sala/Parceiro: {{ googleMeuNegocio.resposta }}
    </h3>

    <!-- Painel de resumo dos campos obrigatórios faltando -->
    <v-alert
      v-if="!isEnviada() && getCamposObrigatoriosNaoPreenchidos().length > 0"
      type="error"
      outlined
      dense
      class="mb-5"
    >
      <div class="d-flex align-center mb-2">
        <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
        <div>
          <strong
            >{{ getCamposObrigatoriosNaoPreenchidos().length }} campo(s)
            obrigatório(s) não preenchido(s)</strong
          >
          <div class="text-caption mt-1">
            Em {{ getGruposComCamposFaltando().length }} grupo(s) • Os grupos
            com pendências estão destacados abaixo
          </div>
        </div>
      </div>
      <div class="campos-faltando">
        <div
          v-for="campo in getCamposObrigatoriosNaoPreenchidos().slice(0, 5)"
          :key="`${campo.grupoId}-${campo.perguntaId}`"
          class="campo-faltando-item"
          @click="scrollToPergunta(campo.grupoId, campo.perguntaId)"
        >
          <v-chip small color="warning" text-color="white" class="mr-2 mb-1">
            {{ campo.grupoNome }}
          </v-chip>
          <span class="campo-texto">{{ campo.perguntaTexto }}</span>
        </div>
        <div
          v-if="getCamposObrigatoriosNaoPreenchidos().length > 5"
          class="mt-2"
        >
          <small class="text--secondary">
            ... e mais
            {{ getCamposObrigatoriosNaoPreenchidos().length - 5 }} campo(s)
          </small>
        </div>
      </div>
    </v-alert>

    <div v-if="isEnviada()" class="enviada">
      <v-icon color="#fff">mdi-alert-circle</v-icon> Já foi finalizado
    </div>
    <v-form ref="form">
      <div v-for="(grupo, i) in perguntas" :key="i" class="grupo">
        <div
          v-if="habilitar(grupo.grupoId)"
          :class="[
            'bloco',
            {
              'grupo-com-campos-faltando':
                temCamposObrigatoriosFaltando(grupo.grupoId) && !isEnviada(),
            },
          ]"
          :style="{ backgroundColor: groupColours[grupo.grupoId] }"
          @click="
            () => {
              onClickOpenGroup(grupo.grupoId);
              $forceUpdate();
            }
          "
        >
          <div class="grupo-header-content">
            <span>{{ grupo.name }}</span>
            <v-chip
              v-if="
                temCamposObrigatoriosFaltando(grupo.grupoId) && !isEnviada()
              "
              small
              color="warning"
              text-color="white"
              class="ml-2"
            >
              {{ getQuantidadeCamposFaltandoGrupo(grupo.grupoId) }} pendente(s)
            </v-chip>
          </div>

          <div v-if="openedGroup != grupo" style="margin-left: auto">
            <v-icon color="#fff">mdi-arrow-down-drop-circle-outline </v-icon>
          </div>
          <div v-if="openedGroup == grupo" style="margin-left: auto">
            <v-icon color="#fff">mdi-arrow-up-drop-circle-outline </v-icon>
          </div>
        </div>
        <div
          :style="{
            display: openedGroup == grupo.grupoId ? 'block' : 'none',
          }"
        >
          <div
            v-for="(children, index) in grupo.children"
            :key="index"
            style="position: relative"
            :style="{ backgroundColor: questionColours[grupo.grupoId] }"
          >
            <div
              :style="
                payload[children.grupoId][children.numero].status == 'loading'
                  ? 'opacity: 0.5'
                  : ''
              "
              :class="[
                'children',
                {
                  'pergunta-obrigatoria-faltando':
                    isPerguntaObrigatoriaFaltando(
                      children.grupoId,
                      children.numero
                    ) && !isEnviada(),
                },
              ]"
              v-if="
                habilitarPergunta(grupo.grupoId, children.numero) &&
                (!children.dependente || mostrarDependente(children))
              "
            >
              <div
                v-html="children.preambulo"
                class="subtitulo mb-4"
                v-if="children.preambulo"
              ></div>

              <div>
                <v-alert
                  v-if="
                    (children.perguntaId == 1 ||
                      children.perguntaId == 69 ||
                      children.perguntaId == 105 ||
                      children.perguntaId == 87 ||
                      children.perguntaId == 124 ||
                      (realizaDigital == 'true'
                        ? children.perguntaId == 63
                        : children.perguntaId == 67)) &&
                    (resposta19 || resposta20)
                  "
                  color="grey darken-2"
                  outlined
                  dense
                  class="mt-2 mb-5"
                >
                  <div v-if="resposta19" class="mb-2">
                    Endereço exato onde todos os canais de atendimento
                    informados (telefone, e-mail e/ou whatsapp) estarão
                    disponíveis:
                    <a
                      :href="resposta19"
                      target="_blank"
                      style="word-break: break-all"
                      >{{ resposta19 }}</a
                    >
                  </div>
                  <div v-if="resposta20">
                    Segunda opção de endereço exato onde todos os canais de
                    atendimento informados (telefone, e-mail e/ou whatsapp)
                    estarão disponíveis:
                    <a
                      :href="resposta20"
                      target="_blank"
                      style="word-break: break-all"
                      >{{ resposta20 }}</a
                    >
                  </div>
                  <div v-if="diaSemana" class="mt-2">
                    <div>
                      Dias de atendimento: <strong>{{ diaSemana }}</strong>
                    </div>
                    <div class="mt-2">
                      Horários de atendimento:
                      <strong> {{ horarioAtendimentoSala }} </strong>
                    </div>
                    <div class="mt-2">
                      Observações de atendimento:
                      <strong> {{ observacaoSobreDiasAtendimento }} </strong>
                    </div>
                  </div>
                </v-alert>

                <v-alert
                  v-if="
                    realizaDigital == 'true'
                      ? children.perguntaId == 63 &&
                        !!(resposta24 || resposta25)
                      : children.perguntaId == 67 &&
                        !!(resposta24 || resposta25)
                  "
                  color="grey darken-2"
                  outlined
                  dense
                  class="mt-2 mb-5"
                >
                  <div
                    v-if="resposta24 && realizaDigital == 'true'"
                    class="mb-2"
                  >
                    Redes Sociais mais utilizadas:
                    <strong>{{ resposta24 }}</strong>
                  </div>
                  <div v-if="resposta25">
                    Links das redes sociais mais utilizadas para comunicação com
                    os clientes:
                    <strong>
                      <div
                        v-for="(link, idx) in resposta25Links"
                        :key="idx"
                        class="mt-1"
                      >
                        <a
                          v-if="link.isUrl"
                          :href="link.href"
                          target="_blank"
                          >{{ link.label }}</a
                        >
                        <span v-else>{{ link.label }}</span>
                      </div>
                    </strong>
                  </div>
                </v-alert>
              </div>

              {{ children.texto }}
              <app-modal-show-evidence
                :evidence="children.evidencia"
                :color="'primary'"
                v-if="children.evidencia"
                :title="'Clique para saber mais'"
                :isHtml="true"
                :titulo="'Informação Importante'"
              >
              </app-modal-show-evidence>

              <div
                v-html="children.subtitulo"
                class="subtitulo mt-2"
                v-if="children.subtitulo"
              ></div>

              <div :class="`filho grupoId_${children.grupoId}`">
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mask="['##:##-##:##']"
                  v-if="children.tipoResposta == tipoDiagnostico.intervalo"
                  placeholder="00:00-00:00"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesMaxIntervalo, rulesObg]
                      : [rulesMaxIntervalo]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.telefone"
                  :placeholder="'(00) 0000-0000'"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesObg]
                      : [true]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mask="['#####-###']"
                  v-if="children.tipoResposta == tipoDiagnostico.cep"
                  :placeholder="'00000-000'"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesMaxCep, rulesObg]
                      : [true]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-textarea
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.textArea"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-textarea>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.numero"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  type="number"
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.texto"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.email"
                  placeholder="Escreva aqui"
                  :rules="emailRules"
                  hide-details="auto"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <div
                  v-if="children.tipoResposta == tipoDiagnostico.boolean"
                  style="width: 100%"
                >
                  <v-radio-group
                    v-model="
                      payload[children.grupoId][children.numero].resposta
                    "
                    :rules="
                      isRulesNeeded(
                        children,
                        payload[children.grupoId][children.numero],
                        payload[children.grupoId][children.numero].desabilitado
                      )
                        ? rules
                        : [true]
                    "
                    hide-details="auto"
                    :name="`resposta${children.grupoId}${children.numero}`"
                    :ref="`resposta${children.grupoId}${children.numero}`"
                    :disabled="
                      payload[children.grupoId][children.numero].status ==
                        'loading' ||
                      isEnviada() ||
                      payload[children.grupoId][children.numero].desabilitado
                    "
                    @change="
                      () => {
                        save(
                          children,
                          grupo,
                          `resposta${children.grupoId}${children.numero}`,
                          i
                        );
                      }
                    "
                  >
                    <v-radio label="Sim" :key="1" :value="true"></v-radio>
                    <v-radio label="Não" :key="2" :value="false"></v-radio>
                  </v-radio-group>
                  <v-autocomplete
                    class="mt-3"
                    v-model="
                      payload[children.grupoId][children.numero]
                        .comentarioPreDefinido
                    "
                    :items="
                      comentariosPreDefinidos(children.grupoId, children.numero)
                    "
                    label="Comentários pré definidos"
                    placeholder="Selecione a comentário"
                    hide-details="auto"
                    @change="
                      (e) => {
                        payload[children.grupoId][children.numero].comentarios =
                          e;
                        save(
                          children,
                          grupo,
                          `comentarios${children.grupoId}${children.numero}`,
                          i
                        );
                      }
                    "
                    filled
                    :disabled="
                      payload[children.grupoId][children.numero].resposta !==
                        false ||
                      isEnviada() ||
                      payload[children.grupoId][children.numero].desabilitado
                    "
                    :readOnly="
                      payload[children.grupoId][children.numero].status ==
                      'loading'
                    "
                    :clearable="true"
                  >
                    <template slot="no-data">
                      Nenhum comentário retornado
                    </template>
                  </v-autocomplete>
                  <v-textarea
                    class="mt-3"
                    label="Comentários"
                    v-model="
                      payload[children.grupoId][children.numero].comentarios
                    "
                    filled
                    placeholder="Escreva aqui"
                    :name="`comentarios${children.grupoId}${children.numero}`"
                    :ref="`comentarios${children.grupoId}${children.numero}`"
                    :rules="
                      deveObrigarComentario(children.grupoId, children.numero)
                        ? rules
                        : [true]
                    "
                    hide-details="auto"
                    :disabled="
                      isEnviada() ||
                      payload[children.grupoId][children.numero].desabilitado
                    "
                    :readOnly="
                      payload[children.grupoId][children.numero].status ==
                      'loading'
                    "
                    @blur="
                      () => {
                        save(
                          children,
                          grupo,
                          `comentarios${children.grupoId}${children.numero}`,
                          i
                        );
                      }
                    "
                  ></v-textarea>
                </div>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mascara="'##:##'"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesHoras, rulesObg]
                      : [rulesHoras]
                  "
                  v-if="children.tipoResposta == tipoDiagnostico.horaMin"
                  hide-details="auto"
                  placeholder="hh:mm"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-autocomplete
                  v-if="children.tipoResposta == tipoDiagnostico.lista115"
                  v-model="payload[children.grupoId][children.numero].resposta"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :items="[
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                  ]"
                  placeholder="Selecione a quantidade"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  @change="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                  :disabled="
                    payload[children.grupoId][children.numero].status ==
                      'loading' || isEnviada()
                  "
                  :clearable="true"
                >
                  <template slot="no-data"> Nenhum Ator retornado </template>
                </v-autocomplete>
                <div
                  style="width: 100%"
                  v-if="
                    children.tipoResposta == tipoDiagnostico.arquivo ||
                    children.tipoResposta == tipoDiagnostico.video ||
                    children.tipoResposta == tipoDiagnostico.audio
                  "
                >
                  <v-file-input
                    :rules="[
                      children.obrigatorio &&
                      payload[children.grupoId][children.numero].files
                        ?.length == 0
                        ? rulesObg
                        : children.obrigatorio &&
                          payload[children.grupoId][children.numero].files &&
                          payload[children.grupoId][children.numero].files
                            .length > children.quantidadePermitida
                        ? `Essa pergunta só aceita até ${children.quantidadePermitida}`
                        : true,
                    ]"
                    :name="`resposta${children.grupoId}${children.numero}`"
                    :ref="`resposta${children.grupoId}${children.numero}`"
                    :accept="children.tipoExtensaoPermitida"
                    placeholder="Selecione o arquivo"
                    v-model="
                      payload[children.grupoId][children.numero].resposta
                    "
                    v-if="!isEnviada()"
                    :disabled="
                      payload[children.grupoId][children.numero].status ==
                        'loading' ||
                      isEnviada() ||
                      (payload[children.grupoId][children.numero].files &&
                        payload[children.grupoId][children.numero].files
                          .length == children.quantidadePermitida)
                    "
                    :hint="`Quantidade de arquivos:
                    ${children.quantidadePermitida} `"
                    persistent-hint
                    @change="
                      () => {
                        save(
                          children,
                          grupo,
                          `resposta${children.grupoId}${children.numero}`,
                          i,
                          true
                        );
                      }
                    "
                  >
                  </v-file-input>
                  <div
                    v-if="
                      isEnviada() &&
                      payload[children.grupoId][children.numero].files.length ==
                        0
                    "
                    style="font-size: 14px; margin: 5px 26px; opacity: 0.5"
                  >
                    Nenhum arquivo enviado
                  </div>
                  <div
                    style="
                      display: flex;
                      row-gap: 20px;
                      flex-direction: column;
                      margin: 0 10px;
                      z-index: 1;
                      position: relative;
                      margin-top: 1rem;
                    "
                    v-if="
                      payload[children.grupoId][children.numero].files &&
                      payload[children.grupoId][children.numero].files.length >
                        0
                    "
                  >
                    <div
                      style="color: #2d6189"
                      v-for="(file, index) in payload[children.grupoId][
                        children.numero
                      ].files"
                      :key="index"
                    >
                      <span
                        style="cursor: pointer"
                        @click="
                          downloadEvidencia(
                            file.evidenciaId,
                            children,
                            payload[children.grupoId][children.numero],
                            file.filename
                          )
                        "
                        >{{ file.filename }}</span
                      >
                      <v-btn
                        outlined
                        color="error"
                        class="ml-3"
                        v-if="!isEnviada()"
                        @click="
                          deleteFile(
                            file.evidenciaId,
                            payload[children.grupoId][children.numero]
                          )
                        "
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="status">
                  <template>
                    <div
                      class="salvar"
                      v-if="
                        payload[children.grupoId][children.numero].status ==
                        'success'
                      "
                    >
                      <v-icon color="#0c6b10"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                      Salvo
                    </div>

                    <div
                      class="salvarErro"
                      v-if="
                        payload[children.grupoId][children.numero].status ==
                        'error'
                      "
                    >
                      <v-icon color="#FF5252">mdi-block-helper</v-icon>
                      Não Salvo
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div
              v-if="
                payload[children.grupoId][children.numero].status == 'loading'
              "
              style="position: absolute; left: 50%; top: 29%; z-index: 1"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <v-btn color="laranja" @click="back()" style="color: #fff">
          {{ !isEnviada() ? "Salvar e sair" : "voltar" }}
        </v-btn>
        <template
          v-if="
            isFullAdmin ||
            (config.podeFinalizarClienteOculto &&
              groupsConfig.podeFinalizarClienteOculto)
          "
        >
          <v-btn
            color="azulclarosc"
            @click="enviarAnalise"
            v-if="!isEnviada()"
            style="color: #fff"
          >
            Finalizar
          </v-btn>
        </template>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import tipoDiagnosticoEnum from "../tipoDiagnostico";

import { cityAPI } from "@/modules/city";
import moment from "moment";

import { seloClienteOcultoPerguntasAPI } from "../API/seloClienteOcultoPerguntasAPI";
import { seloClienteOcultoRespostaAPI } from "../API/seloClienteOcultoRespostaAPI";
import { seloClienteOcultoEvidenciasAPI } from "../API/seloClienteOcultoEvidenciasAPI";
import { groupColours, questionColours } from "../colours";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoEvidenciasAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoEvidenciasAPI";
import { seloClienteOcultoPerguntasComentariosAPI } from "../API/seloClienteOcultoPerguntasComentariosAPI";

import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";

import * as tus from "tus-js-client";
import Swal from "sweetalert2";

export default {
  components: {
    AppModalShowEvidence,
  },
  data() {
    return {
      payload: {},
      openedGroup: null,
      headers: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      municipio: {},
      tiposCampoMapeados: {},
      closeGrupos: {},
      allRespostas: [],
      groupColours: groupColours,
      questionColours: questionColours,
      respostaDiagnosticoSelo: null,
      textoRespostaDiagnosticoSelo: [],
      evidenciasDiagnosticoSelo: [],
      perguntasInscricaoSelo: [12, 13, 14, 15, 23, 25],
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Sala",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
        {
          text: "Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto`,
          exact: true,
        },
      ],
      municipioId: this.$route.params.id,
      rulesHoras: (v) => {
        if (!this.horaRegex.test(v)) {
          return "Hora inválida";
        }
        return true;
      },
      rulesMaxIntervalo: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 11) {
          return "Intervalo inválido";
        }
        return true;
      },
      rulesMaxCep: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 9) {
          return "CEP inválido";
        }
        return true;
      },
      rulesTelCep: (v) => {
        if (v && v.length < 13) {
          return "Telefone inválido";
        }
        return true;
      },
      rulesObg: (v) => {
        if (v === false) {
          return true;
        }
        // eslint-disable-next-line eqeqeq
        if (v == "" || !v) {
          return "Campo Obrigatório";
        }
        return true;
      },

      rulesFile: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 7000000
            ? "Total de arquivos não pode ser maior que 5MB!"
            : true;
        }

        return !files;
      },
      rulesVideo: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 30000000
            ? "Total de arquivos não pode ser maior que 30MB!"
            : true;
        }

        return !files;
      },
      horaRegex: /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/,
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      rules: [
        (v) => {
          if (v === false) {
            return true;
          }
          // eslint-disable-next-line eqeqeq
          if (v == "" || !v) {
            return "Campo Obrigatório";
          }
          return true;
        },
      ],
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      user: JSON.parse(localStorage.getItem("user")),
      perguntas: [],
      // Quantidade de respostas forçadas por cascata ainda sendo persistidas em segundo plano
      pendingCascadeSaves: 0,
      tipoDiagnostico: tipoDiagnosticoEnum,
      perguntasExcecaoComentario: [1, 19, 20, 69, 105, 106, 87, 124, 125],
      allPerguntas: [],
      //  idPerguntaCoringa: 143,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    comentariosPreDefinidos(grupoId, perguntaId) {
      return this.comentarios
        .filter((c) => c.grupoId == grupoId && c.perguntaId == perguntaId)
        .map((c) => c.comentario);
    },
    getComentarios() {
      seloClienteOcultoPerguntasComentariosAPI
        .list(this.municipioId)
        .then((item) => {
          this.comentarios = item.data;
        });
    },
    habilitar(grupoId) {
      if (
        this.realizaTelefone == "true" &&
        this.realizaWhatsapp58 == "true" &&
        (grupoId == 30 || grupoId == 29 || grupoId == 31)
      ) {
        return false;
      }

      if (
        this.realizaTelefone == "false" &&
        (grupoId == 1 || grupoId == 28 || grupoId == 30)
      ) {
        return false;
      }
      if (
        this.realizaWhatsapp58 == "false" &&
        (grupoId == 2 || grupoId == 29 || grupoId == 31)
      ) {
        return false;
      }

      if (this.realizaDigital == "false" && grupoId == 5) {
        return false;
      }

      if (this.isParceiro) {
        if (this.verificaParceiro[`pergunta${grupoId}`]) {
          return this.verificaParceiro[`pergunta${grupoId}`].resposta ==
            "true" ||
            this.verificaParceiro[`pergunta${grupoId}`].resposta == true
            ? true
            : false;
        }

        return true;
      }

      if (this.verifica[`pergunta${grupoId}`]) {
        return this.verifica[`pergunta${grupoId}`].resposta == "true" ||
          this.verifica[`pergunta${grupoId}`].resposta == true
          ? true
          : false;
      }
      return true;
    },

    habilitarPergunta(grupoId, perguntaId) {
      if (
        this.realizaDigital == "false" &&
        (perguntaId == 63 ||
          perguntaId == 64 ||
          perguntaId == 65 ||
          perguntaId == 66)
      ) {
        return false;
      }

      if (this.verificaPerguntas[`pergunta${perguntaId}`]) {
        return this.verificaPerguntas[`pergunta${perguntaId}`].resposta ==
          "true" ||
          this.verificaPerguntas[`pergunta${perguntaId}`].resposta == true
          ? true
          : false;
      }
      return true;
    },
    aparecerAbaixoPerguntaCoringa(perguntaId) {
      const pergunta = this.allPerguntas.filter(
        (p) => p.perguntaId == this.idPerguntaCoringa
      )[0];
      const resposta = this.payload[pergunta.grupoId][pergunta.perguntaId];

      if (resposta && resposta.resposta) {
        return true;
      }

      if (perguntaId > this.idPerguntaCoringa) {
        return false;
      } else {
        return true;
      }
    },
    getRespostaDiagnostico() {
      this.setLoading(true);

      seloDiagnosticoRespostaAPI.list(this.municipioId).then((item) => {
        this.respostaDiagnosticoSelo = item.data;
        this.getEvidenciasDiagnostico();
      });
    },
    getEvidenciasDiagnostico() {
      const idsPerguntas = "12,13,14,15,23, 25";
      seloDiagnosticoEvidenciasAPI
        .getEvidenciaPerguntas53_54_55_56(this.municipioId, idsPerguntas)
        .then((item) => {
          this.evidenciasDiagnosticoSelo = item.data;
          this.getEvidenciaTextoDiagnostico();
        });
    },
    getEvidenciaTextoDiagnostico() {
      seloDiagnosticoRespostaAPI
        .getRespostaPerguntaTexto(this.municipioId)
        .then((item) => {
          this.textoRespostaDiagnosticoSelo = item.data;
          this.setLoading(false);
        });
    },

    statusPreGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      if (
        valoresGrupo.some((item) => {
          // eslint-disable-next-line eqeqeq
          return item.status == "error";
        })
      ) {
        this.perguntas[index].status = "error";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mostrarDependente(children) {
      if (children.respostaDependente == 1) {
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta
        );
      }

      if (children.respostaDependente == 0)
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta === false
        );
    },
    statusGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);

      if (this.grupoCompleto(grupo)) {
        this.perguntas[index].status = "completed";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    onClickOpenGroup(grupo) {
      if (this.openedGroup == grupo) {
        this.openedGroup = null;
      } else {
        this.openedGroup = grupo;
      }
    },
    mapRespostas() {
      seloClienteOcultoRespostaAPI
        .list(this.municipioId)
        .then((item) => {
          let resposta = item.data;
          this.allRespostas = item.data;

          let a =
            resposta.reduce(function (rv, x) {
              rv[x["perguntaGrupoId"]] = { ...rv[x["perguntaGrupoId"]] };
              if (!x.nomeArquivo) {
                rv[x["perguntaGrupoId"]][x["perguntaId"]] = x;
              } else {
                if (rv[x["perguntaGrupoId"]][x["perguntaId"]]) {
                  rv[x["perguntaGrupoId"]][x["perguntaId"]] = [
                    ...rv[x["perguntaGrupoId"]][x["perguntaId"]],
                    x,
                  ];
                } else rv[x["perguntaGrupoId"]][x["perguntaId"]] = [x];
              }

              return rv;
            }, {}) || {};

          this.payload = this.allPerguntas.reduce(function (rv, x) {
            if (
              x.tipoNome.toLowerCase().indexOf("arquivo") > -1 ||
              x.tipoNome.toLowerCase().indexOf("video") > -1 ||
              x.tipoNome.toLowerCase().indexOf("áudio") > -1
            ) {
              if (!rv[x["grupoId"]]) {
                rv[x["grupoId"]] = {};
              }
              if (!a[x["grupoId"]]) {
                a[x["grupoId"]] = {};
              }

              if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null, files: [] };
              } else {
                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]][0],
                  resposta: null,
                  status: "success",
                  files:
                    Array.isArray(a[x["grupoId"]][x["numero"]]) &&
                    a[x["grupoId"]][x["numero"]].map((item) => ({
                      filename: item.nomeArquivo,
                      url: item.url,
                      evidenciaId: item.evidenciaId,
                    })),
                };
              }
            } else {
              if (!a[x["grupoId"]] && !rv[x["grupoId"]]) {
                a[x["grupoId"]] = { ...a[x["grupoId"]] };
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else if (a[x["grupoId"]] && !rv[x["grupoId"]]) {
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "true"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "false"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]] = {};
                rv[x["grupoId"]][x["numero"]] = (a[x["grupoId"]][
                  x["numero"]
                ] && {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                }) || { resposta: null };
              } else if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else {
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "true") {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "false") {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                };
              }
            }

            return rv;
          }, {});

          this.perguntas.forEach((val) => {
            if (this.grupoCompleto(val)) {
              val.status = "completed";
            }

            this.desabilitar(val);
          });

          this.getRespostaDiagnostico();
          this.$forceUpdate();
        })
        .catch((err) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter respostas");

          console.log("mapRespostas err: ", err);
          this.setLoading(false);
        });
    },
    desabilitar(val) {
      const perguntasId = [1, 19, 20, 38, 39, 69, 87, 105, 124];

      const p = val.children.find(
        (item) =>
          perguntasId.includes(item.numero) &&
          this.payload[item.grupoId][item.numero].resposta == false
      );

      val.children.forEach((item) => {
        if (
          item.numero == 63 &&
          this.payload[item.grupoId][item.numero].resposta == false
        ) {
          this.payload[item.grupoId][64].desabilitado = true;
          this.payload[item.grupoId][65].desabilitado = true;
        }
        if (
          item.numero == 64 &&
          this.payload[item.grupoId][item.numero].resposta == false
        ) {
          this.payload[item.grupoId][65].desabilitado = true;
        }
      });

      if (p) {
        // Percorre as próprias definições das perguntas do grupo, ao invés da pergunta
        // gatilho "p", para checar corretamente o tipoResposta de cada dependente
        val.children.forEach((dependente) => {
          if (
            dependente.numero != p.numero &&
            dependente.tipoResposta == this.tipoDiagnostico.boolean
          ) {
            if (this.payload[p.grupoId][p.numero].resposta == false) {
              this.payload[p.grupoId][dependente.numero].desabilitado = true;

              // Autocorrige perguntas que ficaram desabilitadas sem valor salvo por
              // uma falha anterior no salvamento em cascata, mantendo-as pendentes
              if (
                this.payload[p.grupoId][dependente.numero].resposta !== false
              ) {
                console.log(
                  "Desabilitando pergunta",
                  dependente.numero,
                  "porque a pergunta",
                  p.numero,
                  "foi marcada como falsa"
                );
                this.persistirRespostaDesabilitada(dependente);
              }
            } else {
              this.payload[p.grupoId][dependente.numero].desabilitado = false;
            }
          }
        });
      }
    },
    // Ponto único de gravação para respostas forçadas a "false" por cascata de desabilitação,
    // evitando reentrar em save() (com suas validações de ref e sua própria cascata).
    persistirRespostaDesabilitada(pergunta, marcarPeloSistema = false) {
      const resposta = this.payload[pergunta.grupoId][pergunta.numero];
      if (!resposta) return;

      const jaEstavaSalvoComoFalse = resposta.resposta === false;

      resposta.resposta = false;
      if (marcarPeloSistema) {
        this.$set(resposta, "respostaMarcadaPeloSistema", true);
      }

      if (jaEstavaSalvoComoFalse) return;

      resposta.status = "loading";
      this.pendingCascadeSaves++;

      const save = {
        municipioId: this.municipioId,
        usuarioId: this.user.usuarioId,
        perguntaId: pergunta.numero,
        dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
        resposta: false,
        respostaId: resposta.respostaId,
        comentarios: resposta.comentarios || null,
        respondida: true,
        enviada: false,
        perguntaGrupoId: pergunta.grupoId,
      };

      seloClienteOcultoRespostaAPI
        .atualizar(save)
        .then(({ data }) => {
          resposta.respostaId = data.respostaId;
          resposta.status = "success";
          this.pendingCascadeSaves--;
          this.$forceUpdate();
        })
        .catch((err) => {
          resposta.status = "error";
          this.pendingCascadeSaves--;
          console.log(
            "Erro ao salvar automaticamente a resposta da pergunta desabilitada",
            pergunta.numero,
            err
          );
          this.$notification.error(
            `Erro ao salvar automaticamente a pergunta ${pergunta.numero} desabilitada. Abra a página novamente para tentar de novo.`
          );
          this.$forceUpdate();
        });
    },
    // Bloqueia o fechamento/refresh da aba enquanto houver saves de cascata em andamento
    avisarSaidaComSalvamentoPendente(event) {
      if (this.pendingCascadeSaves > 0) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    getOptions(file) {
      return {
        endpoint:
          "https://api.cloudflare.com/client/v4/accounts/e2f8a6cba3853a64e90ed0683c02e9c8/stream",
        headers: {
          Authorization: "Bearer gUgZlz0PyIrgJA1SyZd6s-cVsLQv-3fMqu-6IQNU",
        },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000], // Indicates to tus-js-client the delays after which it will retry if the upload fails
        metadata: {
          filename: file.name,
          filetype: file.type,
        },
      };
    },
    deveObrigarComentario(grupoId, perguntaId) {
      if (!this.payload?.[grupoId]?.[perguntaId]) return false;

      const resposta = this.payload[grupoId][perguntaId];
      const marcadoPeloSistema = !!resposta.respostaMarcadaPeloSistema;

      return (
        resposta.resposta === false &&
        !resposta.desabilitado &&
        !marcadoPeloSistema
      );
    },
    save(children, grupo, nomeForm, index, isFile, isSystemAction = false) {
      // eslint-disable-next-line eqeqeq
      if (this.payload[children.grupoId][children.numero].status == "loading") {
        return;
      }

      this.$forceUpdate();
      const refName = this.$refs[nomeForm][0];
      const valid = refName.validate();
      if (!valid) {
        this.payload[children.grupoId][children.numero].status = "error";
        this.statusPreGrupo(grupo, index);
        this.$forceUpdate();
        return;
      }

      const isBooleanRespostaField =
        children.tipoResposta == this.tipoDiagnostico.boolean &&
        nomeForm.indexOf("resposta") === 0;

      if (isBooleanRespostaField) {
        const respostaAtual = this.payload[children.grupoId][children.numero];
        this.$set(
          respostaAtual,
          "respostaMarcadaPeloSistema",
          respostaAtual.resposta === false ? isSystemAction : false
        );
      }

      if (
        children.numero == 1 ||
        children.numero == 19 ||
        children.numero == 20 ||
        children.numero == 38 ||
        children.numero == 39 ||
        children.numero == 63 ||
        children.numero == 69 ||
        children.numero == 87 ||
        children.numero == 64 ||
        children.numero == 105 ||
        children.numero == 124
      ) {
        const perg65 = this.perguntas
          .find((item) => item.grupoId == 7)
          .children.find((c) => c.numero == 65);

        const perg64 = this.perguntas
          .find((item) => item.grupoId == 7)
          .children.find((c) => c.numero == 64);

        const excecaoComentarioAtiva = this.perguntasExcecaoComentario.includes(
          Number(children.numero)
        );

        Object.keys(this.payload[children.grupoId]).forEach((val) => {
          const p = this.perguntas
            .find((item) => item.grupoId == children.grupoId)
            .children.find((c) => c.numero == val);

          if (
            val != children.numero &&
            p.tipoResposta == this.tipoDiagnostico.boolean &&
            children.numero != 63 &&
            children.numero != 64
          ) {
            if (
              this.payload[children.grupoId][children.numero].resposta ==
                false ||
              this.payload[children.grupoId][children.numero].resposta == 0
            ) {
              this.payload[children.grupoId][val].desabilitado = true;
              if (excecaoComentarioAtiva) {
                this.$set(
                  this.payload[children.grupoId][val],
                  "respostaMarcadaPeloSistema",
                  true
                );
              }

              if (
                this.payload[children.grupoId][val].resposta != false ||
                this.payload[children.grupoId][val].resposta == null
              ) {
                this.persistirRespostaDesabilitada(p, excecaoComentarioAtiva);
                return;
              }
            } else {
              this.payload[children.grupoId][val].desabilitado = false;
              return;
            }
            return;
          }

          if (
            children.numero == 63 &&
            this.payload[7][children.numero].resposta == false
          ) {
            if (
              this.payload[7][64].resposta != false ||
              this.payload[7][64].resposta == null ||
              !this.payload[7][64].desabilitado
            ) {
              this.payload[7][64].desabilitado = true;
              this.persistirRespostaDesabilitada(perg64);
            }

            if (
              this.payload[7][65].resposta != false ||
              this.payload[7][65].resposta == null ||
              !this.payload[7][65].desabilitado
            ) {
              this.payload[7][65].desabilitado = true;
              this.persistirRespostaDesabilitada(perg65);
            }
          } else if (
            children.numero == 64 &&
            this.payload[7][64].resposta == false &&
            this.payload[7][63].resposta != false
          ) {
            if (
              this.payload[7][65].resposta != false ||
              this.payload[7][65].resposta == null ||
              !this.payload[7][65].desabilitado
            ) {
              this.payload[7][65].desabilitado = true;
              this.persistirRespostaDesabilitada(perg65);
            }
          } else if (this.payload[7][63].resposta != false) {
            this.payload[7][64].desabilitado = false;
            if (this.payload[7][64].resposta == false)
              this.payload[7][65].desabilitado = true;
            else {
              this.payload[children.grupoId][val].desabilitado = false;
            }
          }
        });
      }

      const save = {
        municipioId: this.municipioId,
        usuarioId: this.user.usuarioId,
        perguntaId: children.numero,
        dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
        resposta: isFile
          ? ""
          : this.payload[children.grupoId][children.numero].resposta,
        respostaId: this.payload[children.grupoId][children.numero].respostaId,
        comentarios:
          children.tipoResposta == this.tipoDiagnostico.boolean
            ? this.payload[children.grupoId][children.numero].comentarios
            : null,
        respondida: true,
        enviada: false,
        perguntaGrupoId: children.grupoId,
      };

      if (isFile) {
        this.setLoading(true);
        if (!this.payload[children.grupoId][children.numero].resposta) {
          this.setLoading(false);

          return;
        }
      }

      seloClienteOcultoRespostaAPI
        .atualizar(save)
        .then(async ({ data }) => {
          if (isFile) {
            var file = this.payload[children.grupoId][children.numero].resposta;
            if (
              Array.isArray(
                this.payload[children.grupoId][children.numero].resposta
              )
            ) {
              file =
                this.payload[children.grupoId][children.numero].resposta[0];
            }

            if (file.type.indexOf("video") > -1) {
              const minhaPromise = new Promise((resolve, reject) => {
                var upload = new tus.Upload(file, {
                  ...this.getOptions(file, children),
                  onError: function (error) {
                    console.log("error: ", error);
                    throw error;
                  },
                  onSuccess: function () {
                    resolve(upload);
                  },
                });

                upload.start();
              });
              let formData = new FormData();

              const val = await minhaPromise;

              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);
              formData.append("url", val.url);
              formData.append("nomeArquivo", val.file.name);

              seloClienteOcultoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  this.setLoading(false);
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            } else {
              let formData = new FormData();

              if (
                Array.isArray(
                  this.payload[children.grupoId][children.numero].resposta
                )
              ) {
                for (
                  let i = 0;
                  i <
                  this.payload[children.grupoId][children.numero].resposta
                    .length;
                  i++
                ) {
                  formData.append(
                    "arquivo",
                    this.payload[children.grupoId][children.numero].resposta[i]
                  );
                }
              } else {
                formData.append(
                  "arquivo",
                  this.payload[children.grupoId][children.numero].resposta
                );
              }
              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);

              seloClienteOcultoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  this.setLoading(false);
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            }
          } else {
            this.payload[children.grupoId][children.numero].status = "success";
            this.statusGrupo(grupo, index);
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar a pergunta");

          console.log("err: ", err);
          this.payload[children.grupoId][children.numero].status = "error";
          this.statusGrupo(grupo, index);
          this.$forceUpdate();
        });
    },

    downloadEvidenciaDiagnostico(evidenciaId, url, s3) {
      if (url || s3) {
        let link = document.createElement("a");
        link.href = url || s3;
        link.target = "_blank";
        link.click();
      } else {
        seloDiagnosticoEvidenciasAPI
          .download(evidenciaId)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: resp.headers["content-type"],
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },
    downloadEvidencia(evidenciaId, pergunta, resposta, filename) {
      const file = resposta.files.find(
        (item) => item.evidenciaId == evidenciaId
      );
      // eslint-disable-next-line eqeqeq
      if (
        (pergunta.tipoResposta == this.tipoDiagnostico.video ||
          pergunta.tipoResposta == this.tipoDiagnostico.arquivo) &&
        file?.url
      ) {
        let link = document.createElement("a");
        link.href = file.url;
        link.target = "_blank";

        link.click();
      } else {
        seloClienteOcultoEvidenciasAPI
          .download(evidenciaId)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: "application/force-download",
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },
    grupoCompleto(grupo) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      // eslint-disable-next-line eqeqeq
      return valoresGrupo.every((item) => {
        let pergunta = grupo.children.filter(
          (val) => val.perguntaId == item.perguntaId
        )[0];
        return item.status == "success";
      });
    },
    filteredItems() {
      this.setLoading(true);

      seloClienteOcultoPerguntasAPI
        .getPerguntas()
        .then((val) => {
          this.allPerguntas = val.data;
          let groupBy = val.data;

          let key = "grupoId";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.perguntas = Object.keys(aux)
            .map((key) => {
              return {
                grupoId: key,
                name: aux[key] && aux[key][0].grupoNome,
                children: aux[key],
                close: true,
              };
            })
            .sort((a, b) => a.name.localeCompare(b.name));

          this.municipioInfo();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter perguntas");

          console.log("filteredItems err: ", err);
          this.setLoading(false);
        });
    },
    deleteFile(evidenciaId, children) {
      this.payload[children.perguntaGrupoId][children.perguntaId].status =
        "loading";

      seloClienteOcultoEvidenciasAPI
        .delete(evidenciaId)
        .then(() => {
          if (children.files && children.files.length > 0) {
            children.files.forEach((file, index) => {
              // eslint-disable-next-line eqeqeq
              if (file.evidenciaId == evidenciaId) {
                children.files.splice(index, 1);
              }
            });
          }

          this.payload[children.perguntaGrupoId][children.perguntaId].files =
            children.files;
          // eslint-disable-next-line eqeqeq
          if (!children.files || children.files.length == 0) {
            seloClienteOcultoRespostaAPI
              .delete(
                this.payload[children.perguntaGrupoId][children.perguntaId]
                  .respostaId
              )
              .then(() => {
                this.filteredItems();
              })
              .catch((err) => {
                this.setLoading(false);
                console.log(
                  "diagnosticoSelo/List deleteFile delete resposta ",
                  err
                );
                this.$notification.error("Erro ao excluir o arquivo");
              });
          } else {
            this.filteredItems();
          }
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("diagnosticoSelo/List deleteFile delete file", err);
          this.$notification.error("Erro ao excluir o arquivo");
        });
    },
    municipioInfo() {
      this.setLoading(true);
      cityAPI
        .get(this.municipioId)
        .then((municipio) => {
          this.municipio = municipio.data;
          this.mapRespostas();
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("daignosticoSelo/List municipioInfo ", err);
          this.$notification.error("Erro ao buscar municipio");
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();

      return isValid;
    },

    isEnviada() {
      // eslint-disable-next-line eqeqeq
      if (this.allRespostas.length == 0) return false;
      if (this.allRespostas.every((item) => item.enviada)) return true;

      return false;
    },
    isRulesNeeded(pergunta, resposta, desabilitado) {
      if (pergunta.obrigatorio && !pergunta.dependente && desabilitado)
        return true;
      if (pergunta.dependente && pergunta.obrigatorio && !desabilitado) {
        let dependente = this.payload[pergunta.grupoId][pergunta.dependente];
        if (dependente.resposta || dependente.resposta === false) return true;
        else return false;
      }

      return false;
    },
    async enviarAnalise() {
      var isValid = await this.check();

      if (!isValid) {
        const errorElement = document.querySelector(".error--text");
        const grupoId = errorElement.parentNode.className.substring(
          errorElement.parentNode.className.indexOf("grupoId_") + 8,
          errorElement.parentNode.className.length
        );
        this.onClickOpenGroup(grupoId);
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        return;
      }
      Swal.fire({
        title: "Finalizar",
        text: `Ao finalizar os dados não poderão ser alterados. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.enviarAnaliseFim();
        }
      });
    },
    enviarAnaliseFim() {
      this.setLoading(true);
      seloClienteOcultoRespostaAPI
        .enviarAnalise(this.municipioId)
        .then(() => {
          this.setLoading(false);
          this.filteredItems();
          this.$notification.success(
            "O processo de Cliente Oculto foi finalizado com Sucesso. Obrigado!"
          );
        })
        .catch((err) => {
          this.setLoading(false);

          this.$notification.error("Erro finalizar");
          console.log("diagnosticoselo/list enviarAnalise ", err);
        });
    },
    back() {
      if (!this.isEnviada()) {
        Swal.fire({
          title: "As respostas foram salvas",
          text: `Lembramos que o processo do Cliente Oculto não foi finalizado!`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/cidade/" + this.municipioId);
          }
        });
      } else {
        this.$router.push("/cidade/" + this.municipioId);
      }
    },

    // Métodos para validação de campos obrigatórios
    getCamposObrigatoriosNaoPreenchidos() {
      const camposObrigatorios = [];

      if (!this.perguntas || this.perguntas.length === 0) {
        return camposObrigatorios;
      }

      this.perguntas.forEach((grupo) => {
        if (this.habilitar(grupo.grupoId)) {
          grupo.children.forEach((pergunta) => {
            if (
              this.habilitarPergunta(grupo.grupoId, pergunta.numero) &&
              (!pergunta.dependente || this.mostrarDependente(pergunta))
            ) {
              if (
                pergunta.obrigatorio &&
                !this.isPerguntaPreenchida(pergunta.grupoId, pergunta.numero)
              ) {
                let textoExibicao = pergunta.texto;

                // Verifica se é um campo boolean com resposta "Não" que precisa de comentários
                if (
                  pergunta.tipoResposta == this.tipoDiagnostico.boolean &&
                  this.payload[pergunta.grupoId] &&
                  this.payload[pergunta.grupoId][pergunta.numero] &&
                  this.deveObrigarComentario(pergunta.grupoId, pergunta.numero)
                ) {
                  const temComentarios =
                    this.payload[pergunta.grupoId][pergunta.numero]
                      .comentarios &&
                    this.payload[pergunta.grupoId][
                      pergunta.numero
                    ].comentarios.trim() !== "";

                  if (!temComentarios) {
                    textoExibicao = `${pergunta.texto} (Comentários obrigatórios)`;
                  }
                }

                camposObrigatorios.push({
                  grupoId: pergunta.grupoId,
                  perguntaId: pergunta.numero,
                  grupoNome: grupo.name,
                  perguntaTexto: textoExibicao,
                });
              }
            }
          });
        }
      });

      return camposObrigatorios;
    },

    isPerguntaPreenchida(grupoId, perguntaId) {
      if (
        !this.payload ||
        !this.payload[grupoId] ||
        !this.payload[grupoId][perguntaId]
      ) {
        return false;
      }

      const resposta = this.payload[grupoId][perguntaId];

      // Verifica se é um campo de arquivo/vídeo/áudio
      const pergunta = this.allPerguntas.find(
        (p) => p.grupoId == grupoId && p.numero == perguntaId
      );
      if (
        pergunta &&
        (pergunta.tipoResposta == this.tipoDiagnostico.arquivo ||
          pergunta.tipoResposta == this.tipoDiagnostico.video ||
          pergunta.tipoResposta == this.tipoDiagnostico.audio ||
          pergunta.tipoNome.toLowerCase().indexOf("arquivo") > -1 ||
          pergunta.tipoNome.toLowerCase().indexOf("video") > -1 ||
          pergunta.tipoNome.toLowerCase().indexOf("áudio") > -1)
      ) {
        return resposta.files && resposta.files.length > 0;
      }

      // Para campos boolean, verifica se tem resposta definida
      if (pergunta && pergunta.tipoResposta == this.tipoDiagnostico.boolean) {
        const temResposta =
          resposta.resposta === true || resposta.resposta === false;

        // Se respondeu "Não" (false) e não está desabilitado, verifica se tem comentários
        if (this.deveObrigarComentario(grupoId, perguntaId)) {
          const temComentarios =
            resposta.comentarios && resposta.comentarios.trim() !== "";
          return temResposta && temComentarios;
        }

        return temResposta;
      }

      // Para outros tipos de campo
      return (
        resposta.resposta !== null &&
        resposta.resposta !== undefined &&
        resposta.resposta !== ""
      );
    },

    isPerguntaObrigatoriaFaltando(grupoId, perguntaId) {
      const pergunta = this.allPerguntas.find(
        (p) => p.grupoId == grupoId && p.numero == perguntaId
      );
      if (!pergunta || !pergunta.obrigatorio) {
        return false;
      }

      return !this.isPerguntaPreenchida(grupoId, perguntaId);
    },

    temCamposObrigatoriosFaltando(grupoId) {
      const grupo = this.perguntas.find((g) => g.grupoId == grupoId);
      if (!grupo) return false;

      return grupo.children.some((pergunta) => {
        if (
          this.habilitarPergunta(grupoId, pergunta.numero) &&
          (!pergunta.dependente || this.mostrarDependente(pergunta))
        ) {
          return (
            pergunta.obrigatorio &&
            !this.isPerguntaPreenchida(pergunta.grupoId, pergunta.numero)
          );
        }
        return false;
      });
    },

    getQuantidadeCamposFaltandoGrupo(grupoId) {
      const grupo = this.perguntas.find((g) => g.grupoId == grupoId);
      if (!grupo) return 0;

      return grupo.children.filter((pergunta) => {
        if (
          this.habilitarPergunta(grupoId, pergunta.numero) &&
          (!pergunta.dependente || this.mostrarDependente(pergunta))
        ) {
          return (
            pergunta.obrigatorio &&
            !this.isPerguntaPreenchida(pergunta.grupoId, pergunta.numero)
          );
        }
        return false;
      }).length;
    },

    getGruposComCamposFaltando() {
      return this.perguntas.filter((grupo) =>
        this.temCamposObrigatoriosFaltando(grupo.grupoId)
      );
    },

    scrollToPergunta(grupoId, perguntaId) {
      // Abre o grupo se estiver fechado
      if (this.openedGroup != grupoId) {
        this.onClickOpenGroup(grupoId);
        this.$forceUpdate();
      }

      // Aguarda o DOM atualizar e depois faz o scroll
      this.$nextTick(() => {
        let elemento = document.querySelector(
          `[name="resposta${grupoId}${perguntaId}"]`
        );

        // Verifica se é um campo boolean com resposta "Não" que precisa de comentários
        const pergunta = this.allPerguntas.find(
          (p) => p.grupoId == grupoId && p.numero == perguntaId
        );
        if (
          pergunta &&
          pergunta.tipoResposta == this.tipoDiagnostico.boolean &&
          this.payload[grupoId] &&
          this.payload[grupoId][perguntaId] &&
          this.deveObrigarComentario(grupoId, perguntaId)
        ) {
          const temComentarios =
            this.payload[grupoId][perguntaId].comentarios &&
            this.payload[grupoId][perguntaId].comentarios.trim() !== "";

          // Se não tem comentários, foca no campo de comentários
          if (!temComentarios) {
            const elementoComentarios = document.querySelector(
              `[name="comentarios${grupoId}${perguntaId}"]`
            );
            if (elementoComentarios) {
              elemento = elementoComentarios;
            }
          }
        }

        if (elemento) {
          elemento.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });

          // Adiciona um highlight temporário
          elemento.style.boxShadow = "0 0 10px rgba(255, 152, 0, 0.8)";
          setTimeout(() => {
            elemento.style.boxShadow = "";
          }, 2000);
        }
      });
    },
  },

  // Guard de navegação do vue-router: precisa ficar aqui fora de methods
  beforeRouteLeave(to, from, next) {
    if (this.pendingCascadeSaves > 0) {
      const continuar = window.confirm(
        "Ainda há respostas sendo salvas automaticamente (perguntas desabilitadas pela cascata). Se sair agora, algumas podem não ser salvas. Deseja sair mesmo assim?"
      );
      if (!continuar) {
        next(false);
        return;
      }
    }
    next();
  },

  beforeMount() {
    if (this.isParceiro) {
      // this.idPerguntaCoringa = 115;

      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Parceiro",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/geral`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
        {
          text: "Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto`,
          exact: true,
        },
      ];
    }
    this.filteredItems();
    this.getComentarios();
    window.addEventListener("beforeunload", this.avisarSaidaComSalvamentoPendente);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.avisarSaidaComSalvamentoPendente);
  },

  computed: {
    ...mapGetters(["isSala", "isFullAdmin", "isParceiro"]),
    googleMeuNegocio() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 8 || item.perguntaId == 8
        )
      );
    },
    telefonePergunta1() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 18 || item.perguntaId == 20
        )
      );
    },
    telefonePergunta2() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 22)
      );
    },
    instagram55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 160 && item && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 161);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 160 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 161);

      return resposta && resposta.resposta == "true" ? insta : null;
    },
    facebook55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 162 && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 163);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 162 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 163);

      return resposta && resposta.resposta == "true" ? insta : null;
    },
    sieBlog55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 164 && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 165);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 164 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 165);

      return resposta && resposta.resposta == "true" ? insta : null;
    },
    resposta19() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 18 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    resposta20() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 19 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    resposta24() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 24 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    resposta25() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 25 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    diaSemana() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 20 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    horarioAtendimentoSala() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 21 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    observacaoSobreDiasAtendimento() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 22 && item.resposta
        );

      return (resposta && resposta.resposta) || null;
    },
    resposta25Links() {
      if (!this.resposta25) return [];

      const tokens = this.resposta25
        .split(/(?=https?:\/\/)|(?=@)/i)
        .flatMap((part) => part.trim().split(/\s+/))
        .filter((s) => s.length > 0);
      return tokens.map((entry) => {
        const isUrl = /^https?:\/\//i.test(entry);
        return {
          label: entry,
          href: isUrl ? entry : null,
          isUrl,
        };
      });
    },
    verifica() {
      return {
        pergunta1:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 15),
        pergunta2:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta3:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
      };
    },
    verificaPerguntas() {
      return {
        pergunta53:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta54:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta55:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta50:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
        pergunta51:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
        pergunta52:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
      };
    },
    verificaParceiro() {
      return {
        pergunta1:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 15),
        pergunta2:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta3:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
      };
    },
    realizaTelefone() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 15 && item.resposta
        );

      return resposta && resposta.resposta ? resposta.resposta : null;
    },
    realizaWhatsapp58() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 12 && item.resposta
        );

      return resposta && resposta.resposta ? resposta.resposta : null;
    },
    realizaDigital() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 23 && item.resposta
        );

      return resposta && resposta.resposta ? resposta.resposta : null;
    },
    redeSocial() {
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 18 && item.resposta
        );

      return resposta && resposta.resposta ? resposta : null;
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitulo {
  font-size: 14px;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  margin-top: 1rem;
}
.grupo {
  margin-bottom: 1rem;
}

.imagensDiagnostico {
  display: flex;
  flex-wrap: wrap;
  column-gap: 5px;
  margin-top: 10px;
  .arquivo {
    background: #2d6189;
    color: #fff;
    padding: 10px;
    border-radius: 10px;
    font-size: inherit;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .arquivo:hover {
    background: #03528f;
  }
}

.enviada {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
  margin: 2rem;
  font-size: 20px;
  /* font-weight: bold; */
  background: #606060;
  border-radius: 19px;
  padding: 10px;
  color: #fff;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.salvar {
  color: #0c6b10;
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.status {
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.salvarErro {
  color: #ff5252;
}

.bloco {
  position: sticky;
  top: 0px;
  background: #2d6189;
  color: #fff;
  padding: 10px;
  z-index: 2;
  display: flex;
  column-gap: 10px;
  cursor: pointer;
}
.completed {
  background: #0c6b10;
}

.error {
  background: #ff5252;
}

.inProgress {
  background: #f57d30;
  color: #fff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.38);
}

.children {
  border: 1px solid #c1bebe8c;
  position: relative;
  .filho {
    display: flex;
  }
}
.children {
  padding: 10px;

  .numeration {
    font-weight: bold;
    font-size: 14px;
  }
}

.pergunta-obrigatoria-faltando {
  background: linear-gradient(
    90deg,
    rgba(255, 152, 0, 0.1),
    rgba(255, 152, 0, 0.05)
  ) !important;
  border-left: 3px solid #ff9800 !important;
  border-radius: 4px !important;
  margin-bottom: 8px !important;
  position: relative;
}

.pergunta-obrigatoria-faltando::before {
  content: "⚠️";
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 16px;
  animation: bounce 1s ease-in-out infinite;
}

.campo-faltando-item {
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.campo-faltando-item:hover {
  background-color: rgba(255, 152, 0, 0.1);
}

.campo-texto {
  font-size: 14px;
  line-height: 1.4;
}

@keyframes pulseWarning {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-5px);
  }
  60% {
    transform: translateY(-3px);
  }
}
</style>
